import React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import "./scriptsearch.css";

const ScriptSearch = ({ search, setSearch }) => {
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const handleClear = () => {
    setSearch("");
  };

  return (
    <div className="search-section">
      <Paper
        component="form"
        sx={{
          p: "2px 4px",
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1, fontSize: "16px" }}
          onChange={handleSearch}
          value={search}
          placeholder="Search"
          inputProps={{ "aria-label": "search" }}
        />
        <IconButton
          sx={{ p: "10px" }}
          onClick={handleClear}
          aria-label="search"
        >
          <HighlightOffIcon />
        </IconButton>
      </Paper>
    </div>
  );
};

export default ScriptSearch;
